module.exports = __webpack_public_path__ + "img/icon_map_4_off_111.79204c5c.png";